















































import { Component, Vue } from "vue-property-decorator";
import { eachDayOfInterval } from "date-fns";

import Chart from "../models/chart";
import VChartHeader from "../components/chart/VChartHeader.vue";
import VChart from "../components/chart/VChart.vue";
import VChartRow from "../components/chart/VChartRow.vue";
import VProxyWindow from "../components/VProxyWindow.vue";

import ScheduleComponent from "@/ui/schedule/components/Schedule.vue";
import { client } from "@/api/request";
import ScheduleCalendarApi from "../api/schedule/schedule-calendar-api";
import ScheduleViewModel from "@/ui/schedule/presenters/schedule";
import ScheduleEventListModal from "@/ui/schedule/pages/ScheduleEventListModal.vue";
import NewScheduleEventModal from "../ui/schedule/pages/NewScheduleEventModal.vue";
import EditScheduleEventModal from "../ui/schedule/pages/EditScheduleEventModal.vue";
import ScheduleCalendarSearchBar from "../ui/schedule/components/ScheduleCalendarSearchBar.vue";
import ScheduleCalendarSearchOptions from "../schedule/usecases/schedule-calendar-search-options";
import { getServiceRoles, ServiceRole } from "../api/service-api";
import SelectYearAndMonth from "../common/ui/components/SelectYearAndMonth.vue";
import VToolbar from "@/components/V-Toolbar.vue";

const calendarApi = new ScheduleCalendarApi(client);

@Component({
  components: {
    VToolbar,
    SelectYearAndMonth,
    VChart,
    VChartRow,
    VProxyWindow,
    VChartHeader,
    NewScheduleEventModal,
    EditScheduleEventModal,
    Schedule: ScheduleComponent,
    ScheduleEventListModal,
    ScheduleCalendarSearchBar
  }
})
export default class ScheduleCalendarPage extends Vue {
  calendars: ScheduleViewModel[] = [];
  searchOptions: ScheduleCalendarSearchOptions = {
    role: ""
  };

  moveDate(year: number, month: number) {
    this.chart.moveDateByNumbers(year, month);
    this.initCalendarList();
  }

  get days(): Date[] {
    return eachDayOfInterval(this.chart);
  }

  get roleOptions() {
    return [
      {
        text: "(職種)",
        value: ""
      }
    ].concat(
      this.roles.map(r => ({
        text: r.name,
        value: String(r.id)
      }))
    );
  }

  goNext() {
    this.moveChart(1);
  }

  goPrev() {
    this.moveChart(-1);
  }

  /**
   * 列数の自動調整
   */
  resize(width: number) {
    // 先にresizeされるのを防ぐためにsettimeout
    setTimeout(() => {
      this.chart.adjust(width);
      this.initCalendarList();
    }, 100);
  }

  clickCell(userId: number, date: Date) {
    (this.$refs.list as ScheduleEventListModal).show(userId, date);
  }

  create(date: Date) {
    (this.$refs.create as NewScheduleEventModal).show(date);
  }

  edit(id: number) {
    (this.$refs.edit as EditScheduleEventModal).show(id);
  }

  search() {
    this.initCalendarList();
  }

  protected created() {
    this.initCalendarList();
    this.loadRoleList();
  }

  private chart = new Chart(new Date(), 10);

  async initCalendarList() {
    const calendars = await calendarApi.findByPeriod(
      this.chart,
      this.searchOptions
    );
    this.calendars = calendars.map(c => new ScheduleViewModel(c));
  }

  private async moveChart(step: number) {
    // TODO 移動幅を自動調整にして、Chartに移す
    this.chart.move(step * 7);
    this.initCalendarList();
  }
  private roles: ServiceRole[] = [];

  private async loadRoleList() {
    this.roles = await getServiceRoles();
  }
}
